import { makeAutoObservable } from "mobx";
import type { BasketFormValues } from "helpers/forms/baseTypes";
import type { FeatureStore } from "services/feature/featureStore";
import { PricingPlanStore } from "services/pricingPlan/gb/pricingPlanStore";
import type { PricingPlanGb } from "services/pricingPlan/pricingPlanTypes";
import { FormError } from "types/errors";

export class PricingStepStore {
  constructor(
    private readonly _pricingPlanStore: PricingPlanStore,
    private readonly _featureStore: FeatureStore,
  ) {
    makeAutoObservable(this);
  }

  async updateEntity(data: BasketFormValues): Promise<void> {
    await this._updatePricingPlan(data.pricingPlan);
  }

  private async _updatePricingPlan(pricingPlan?: PricingPlanGb): Promise<void> {
    if (!pricingPlan) {
      throw new FormError("No pricing plan selected");
    }
    // New-pricing only: the always-visible pricing step makes same-plan re-submits
    // common — skip the no-op update (and its basket.change-plan analytics event).
    // Control keeps the pre-experiment behavior untouched.
    if (
      this._featureStore.hasFeature("formationsNewPricingJul") &&
      pricingPlan === this._pricingPlanStore.tryGetPricingPlan()
    ) {
      return;
    }
    await this._pricingPlanStore.updatePricingPlan(pricingPlan);
  }
}
